import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography'
import Aztec from './Aztec.jpg'

const classes= {
    root : {
        flexGrow: 1,
        padding: 5,
        backgroundColor: '#b2dfdb',
        color: '#6a737b',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 30,
        elevation: '20',
    },
    h1 : {
        margin:'auto',
        align:'center',
        justify:'center',
        color: '#009688',
        paddingBottom:20,
        borderBottom: 'solid 0.02em',
        width:'40%',
        marginBottom:60
        },
   
    p :{
        color: '#333333' ,
        paddingLeft: 20,
        marginTop:30,
        marginBottom: 80,
    },
    pImag :{
            color: '#333333' ,
            paddingLeft: '20%',
            paddingTop: '3%',
            marginBottom:30}   
          
    }

export class Research extends Component {
    render() {
        return ( 
            <div align="left" style={{margin:'7%'}}>
            
 <Typography align="center" variant="h4" style={classes.h1}>Stochastic Models</Typography>
    
 <Typography  style={classes.p}>
In many situations we have a stochastic microscopic model of some kind and we want to understand what happens for large such systems. Often a macroscopic, non-random shape of some form emerges. This limit shape typically depends on the details of the model and is often described by some variational principle or a differential equation. If we look at the microscopic details of the model they will also depend on the specific model. However, random fluctuations of the the limit shape at an intermediate scale are very often universal, i.e. they are the same within broad classes of models. This phenomenon is called universality. A classical example is the central limit theorem which is a universal limit law in many situations. missing It is a very interesting and surprising fact, that has only emerged in the last 15-20 years, that in many cases the fluctuations around the limit shape are the same as the distributions that appear in random matrix theory and these laws appear to be universal.
<img src={Aztec} height="300" style={{float:'right', margin:'3%'}}  alt="missing"/>,
One basic example is the Tracy-Widom distribution for the largest eigenvalues of big matrices. Investigating this phenomenon and proving the occurrence of these laws in various models has been a central research theme for the group at KTH. Typical models are local random growth models, directed polymers and random tiling/dimer models.

The figure on the right shows a random uniform tiling of a shape called the Aztec diamond. We can see a shape emerging in this picture, namely the interface between the disordered region in the center and the completely ordered tiling surrounding it. This is interface has fluctuations described by the Tracy-Widom distribution which originated in random matrix theory. The mathematics behind these developments is very rich with connections to asymptotic analysis, combinatorics, representation theory, special functions, mathematical physics, probability theory and more. Some of the results have also been verified experimentally in random growth experiments. The area is very active at the moment with many new developments. Ongoing research at KTH is concerned for example with with models generalizing the Aztec diamond and deeper properties of random growth models.
</Typography>
<Typography variant="h4" align="center" style={classes.h1}>
    Random Matrices
    </Typography>
    
    <Typography  style={classes.p}>
        Random matrices are an attractive class of models for large stochastic systems. Their study connects mathematics with many branches of science such as statistics, physics, computer science and genomics to mention a few. In statistics, random matrices were introduced by Wishart in 1928 as part of the statistical analysis of large samples as associated sample covariance matrices. In physics, they were introduced by Wigner in 1955 in the study of energy levels of heavy nuclei. Wigner envisioned that the energy levels of large complex quantum systems behave in the same way as the eigenvalues of large matrices whose entries are independent random variables, and that the emerging behavior is universal in the sense that it depends only on the basic symmetry type of the systems but is otherwise independent of the details. While we still do not understand universality for most physically realistic models, spectacular progress was made in the last decade in deriving universality for Wigner random matrices with parallel results for sample covariance matrices. The developed methods combine powerful tools from probability theory, functional analysis and mathematical physics. Interesting applications yielding a strong link to high dimensional statistical inference and stochastic growth models include the derivation of Tracy–Widom fluctuations of the largest eigenvalue for various random matrix ensembles. Ongoing research at KTH focuses on the understanding of the universality phenomena in more general and more physical models, on connections to quantum physics, spectral theory, integrable probability and the theory of free probability, as well as on applications in mathematical statistics and in the theory of random networks.
        </Typography>
        <Typography variant="h4" align="center" style={classes.h1}>   Analysis
</Typography>
 
<Typography  style={classes.p}>
    The research activities in our group are strongly related to analysis. In studying various universality questions of interest one often relies on methods and techniques from fields such as complex analysis, potential theory, ordinary differential equations and spectral theory. An important connection is with the theory of orthogonal polynomials and their asymptotic properties as the degree becomes large. In the late 90's the Riemann-Hilbert approach for those polynomials was introduced to obtain various asymptotic results, including a first proof of the universality for the microscopic behavior of the eigenvalues of Unitary Ensembles. This complex analytical tool proved to be very fruitful. In particular, in the study of singular behaviors or phase transitions where remarkable connections have been found with special functions such as the Painlevé transcendents. It has also been successfully applied to the asymptotic analysis of Toeplitz determinants with Fisher-Hartwig symbols. This is an active area with interesting ongoing developments. A notion strongly related to orthogonal polynomials that plays a prominent role in random matrix theory are Jacobi matrices and CMV matrices. For instance, gaussian beta ensembles can be represented as eigenvalues of random Jacobi matrices or CMV matrices. This opens up interesting connections to spectral theory. A recent development that has been of particular interest in the research group at KTH, is the use of Jacobi matrices in the analysis of fluctuations of macroscopic and mesoscopic linear statistics for determinantal point processes. This is a new approach for understanding the global fluctuations and the random Gaussian fields that arise. A topic that currently witnesses a high activity in the literature. 
</Typography>
<Typography variant="h4" align="center" style={classes.h1}>  
     References
</Typography>
<Typography  style={classes.p}>
Some references for previous research at KTH:
<ul> 
<li>
J. Baik, P. Deift, and K. Johansson, On the distribution of the length of the longest increasing subsequence of random permutations. J. Amer. Math. Soc. 12 (1999), no. 4, 1119–1178
</li>
<li>
    Z. Bao, L. Erdos and K. Schnelli, Local law of addition of random matrices on optimal scale, Comm. Math. Phys. 349 (2017), no. 3, 947-990
</li>
<li>
J. Breuer and M. Duits, Central Limit Theorems for biorthogonal ensembles and asymptotics of recurrence coefficients, J. Amer. Math. Soc. 30 (2017) no. 1, 27-66. (arXiv:1309.6224)
</li>
<li>
S. Chhita and K. Johansson, Domino statistics of the two-periodic Aztec diamond. Adv. Math. 294 (2016), 37–149
</li>
<li>
    M. Duits and D. Geudens, A critical phenomenon in the two-matrix model in the quartic/quadratic case, Duke Math. J. 162 (2013) no. 8, 1383--1462. (arXiv:1111.2162)
</li>
<li>
    M. Duits and A. Kuijlaars, The two periodic Aztec diamond and matrix valued orthogonal polynomials, arXiv (2017)
</li>
<li>
    M. Duits, On global fluctuations for non-colliding processes, Ann. Probab. 46.3 1279-1350 (2018)
 </li>
<li>
    K. Johansson, Shape fluctuations and random matrices. Comm. Math. Phys. 209, no. 2, 437–476 (2000)
 </li>
<li>K. Johansson, Two Time Distribution in Brownian Directed Percolation, Comm. Math. Phys. 351, no. 2, 441-492 (2017)
</li>
<li>
    R. Kozhan and M. Duits, Relative Szego Asymptotics for Toeplitz determinants, International Mathematics Research Notices (2016)
</li>
<li>
    J. O. Lee and K. Schnelli, Local law and Tracy-Widom limit for sparse random matrices, Probab. Theory Related Fields 171(1), 543-616 (2018)
</li>
<li>
    J. O. Lee and K. Schnelli, Tracy-Widom distribution for the largest eigenvalue of real sample covariance matrices with general population, Ann. Appl. Probab. 26, no. 6, 3786-3839 (2016)
</li>
</ul>
Some review papers:
<ul>
<li>
    D. Aldous and P. Diaconis, Longest increasing subsequences: from patience sorting to the Baik-Deift-Johansson theorem. Bull. Amer. Math. Soc. (N.S.) 36 (1999), no. 4, 413–432

A. Borodin and V. Gorin, Lectures on integrable probability, arXiv:1212.3351
</li>
<li>
P. Deift, Orthogonal Polynomials and Random Matrices: A Riemann-Hilbert Approach, Courant Lecture Notes, vol. 3, New York, American Mathematical Society 2000
</li>
<li>
I. Corwin, Kardar-Parisi-Zhang universality. Notices Amer. Math. Soc. 63 (2016), no. 3, 230–239
</li>
<li>
L. Erdos and H.-T. Yau, Universality of local spectral statistics of random matrices, Bull. Amer. Math. Soc. 49(3), 377-414, (arXiv:1106.4986)
</li>
<li>
K. Johansson, Kurt Random matrices and determinantal processes. Mathematical statistical physics, 1–55, Elsevier B. V., Amsterdam, 2006
</li>
<li>
I. M. Johnstone, High Dimensional Statistical Inference and Random Matrices, Proc. International Congress of Mathematicians 2006, 307-333, (arXiv:math/0611589)
</li>
<li>
A.B.J. Kuijlaars, Universality, in: “Oxford Handbook on Random Matrix theory”, edited by G. Akemann, J. Baik and P. Di Francesco, Oxford University Press, 2011.
</li>
</ul>
</Typography>
</div>
        );
    }
}

export default Research;